import { roundNumber } from 'shared/utils/helpers/roundNumber';

export const addPercent = (value: number, percent: number): number => roundNumber(((100 + percent) / 100) * value, 2);
